import { AxiosResponse, AxiosPromise, AxiosError } from 'axios';

export { AxiosError };

export const makeCodedException = async <T>(request: AxiosPromise<T>) => {
    try {
        return await request;
    } catch (e) {
        const error = e as AxiosError<ExceptionResponse>;
        if (error.response) {
            // enforce ExceptionResponse structure onto error.response.data
            error.response.data.Error = <ExceptionData>error.response.data.Error || {};
        }
        return Promise.reject(error);
    }
};

export function isValidationException(error: ExceptionData) {
    return error.FieldErrors !== undefined;
}

export interface ExceptionResponse {
    Error: ExceptionData;
}

export interface MockResponseConfig<T> {
    response?: Partial<AxiosResponse<Partial<T>>>;
    error?: Partial<AxiosError<ExceptionResponse>>;
    responseCount?: number;
}

export const makeContent = (content: any, unspecifiedPaths: string[]) => {
    const paths = new Map<any, string>();
    const pathsSegments = unspecifiedPaths.map(p => splitPath(p));

    return JSON.stringify(content, function (key, value) {
        const path =
            (paths.get(this) ?? '$') + (Array.isArray(this) ? '[*]' : key ? '.' + key : '');
        const originalValue = this[key];
        if (originalValue !== null && typeof originalValue === 'object') {
            paths.set(originalValue, path);
        }

        return matchPath(path, pathsSegments) && originalValue != null ? originalValue : value;
    });
};

const splitPath = (path: string) => path.split(/\.|(?=\[\*\])/);

const matchPath = (path: string, pathsSegments: string[][]) => {
    const segments = splitPath(path);
    for (const pathSegments of pathsSegments) {
        if (
            pathSegments.length === segments.length &&
            segments.every((s, i) => s === pathSegments[i] || pathSegments[i] === '[*]')
        ) {
            return true;
        }
    }

    return false;
};

export interface ExceptionData {
    Message: string;
    Code?: string | undefined;
    FieldErrors?: { [key: string]: string } | undefined;
}
